module.exports = "<div  id=\"privacyPolicyDiv\"> \r\n    <!-- <iframe height=\"100%\" width=\"100%\" style=\"height:90%;\" [src]=\"url | safe\"></iframe> -->\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/privacy-policy/privacy-policy.component.html
// module id = ./src/app/privacy-policy/privacy-policy.component.html
// module chunks = main